import React from 'react';

export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  icon,
  ...props
}) => {
  const baseStyle = "inline-flex items-center justify-center font-medium rounded-xl transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2";

  const variants = {
    primary: "bg-[#1674B8] text-white hover:bg-[#12649E] focus:ring-[#1674B8] shadow-sm",
    secondary: "bg-white text-[#183153] border border-[#DCE5EF] hover:bg-[#F8FBFF] focus:ring-[#1674B8] shadow-sm",
    ghost: "text-slate-600 hover:bg-slate-100 hover:text-slate-900 focus:ring-slate-500",
    danger: "bg-[#D95C66] text-white hover:bg-[#C94D59] focus:ring-[#D95C66]",
  };

  const sizes = {
    sm: "px-3 py-1.5 text-sm gap-1.5",
    md: "px-4 py-2 text-sm gap-2",
    lg: "px-6 py-3 text-base gap-2",
  };

  return (
    <button
      className={`${baseStyle} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {icon && <span className="text-current opacity-80">{icon}</span>}
      {children}
    </button>
  );
};